export default __webpack_public_path__ + "static/media/tab.65e057b2.svg";